class PaginationLoadMoreButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.handleClick);
    this.addEventListener("keydown", this.handleClick);
  }

  handleClick(event) {
    if (event.type === "keydown" && event.keyCode !== 13) {
      return;
    }

    event.preventDefault();

    function updateItems(DOM) {
      const existingProducts = document.querySelector(
        "[data-pagination-item-container]"
      );

      
      const newProducts = DOM.querySelector("[data-pagination-item-container]");

      // Removing duplicate images that appear before pagination
      DOM.querySelectorAll(".collection__grid-item--promo").forEach(node => node.remove());
  
      //data-collection-items-insertion
      //existingProducts.innerHTML += newProducts.innerHTML;
      document.querySelector("[data-collection-items-insertion]").insertAdjacentHTML("beforebegin", newProducts.innerHTML);
    }

    function updatePagination(DOM) {
      const existingPagination = document.querySelector("[data-pagination]");
      const newPagination = DOM.querySelector("[data-pagination]");

      existingPagination.innerHTML = newPagination.innerHTML;
    }

    this.addLoading();

    fetch(this.dataset.href)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const DOM = parser.parseFromString(html, "text/html");

        this.removeLoading();

        updateItems(DOM);
        updatePagination(DOM);
      })
      .catch(() => {
        window.location = this.dataset.href;
      });
  }

  addLoading() {
    const pagination = this.closest("[data-pagination]");

    pagination.classList.add("pagination--is-loading");
  }

  removeLoading() {
    const pagination = this.closest("[data-pagination]");

    pagination.classList.remove("pagination--is-loading");
  }
}

customElements.define("pagination-load-more-button", PaginationLoadMoreButton);

class PaginationViewAllButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.handleClick);
    this.addEventListener("keydown", this.handleClick);
  }

  handleClick(event) {
    if (event.type === "keydown" && event.keyCode !== 13) {
      return;
    }

    event.preventDefault();

    const url = window.location.search
      ? `${window.location}&view=all-products`
      : `${window.location}?view=all-products`;

    function updateItems(DOM) {
      const existingProducts = document.querySelector(
        "[data-pagination-item-container]"
      );
      const newProducts = DOM.querySelector("[data-pagination-item-container]");

      existingProducts.innerHTML = newProducts.innerHTML;
    }

    function removePagination() {
      const existingPagination = document.querySelector("[data-pagination]");

      existingPagination.remove();
    }

    this.addLoading();

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const DOM = parser.parseFromString(html, "text/html");

        updateItems(DOM);
        removePagination(DOM);
      })
      .catch(() => {
        window.location = url;
      });
  }

  addLoading() {
    const pagination = this.closest("[data-pagination]");

    pagination.classList.add("pagination--is-loading");
  }
}

customElements.define("pagination-view-all-button", PaginationViewAllButton);
